module.exports = __webpack_public_path__ + "img/go-min.f1cfeee3.jpg";